'use client'

import Link from 'next/link'

export default function LobbyError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <div className="text-center space-y-4 max-w-md">
        <h1 className="text-2xl font-semibold text-atrium-black">Something went wrong</h1>
        {error.message && process.env.NODE_ENV !== 'production' && (
          <p className="text-sm text-atrium-muted">{error.message}</p>
        )}
        {error.digest && (
          <p className="font-mono text-xs text-atrium-muted/70">
            error id: {error.digest}
          </p>
        )}
        <div className="flex items-center justify-center gap-4 pt-2">
          <button
            onClick={reset}
            className="px-4 py-2 bg-accent-600 hover:bg-accent-700 text-white text-sm font-medium rounded-lg transition-colors"
          >
            Try again
          </button>
          <Link
            href="/"
            className="text-sm text-atrium-muted hover:text-atrium-black transition-colors"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  )
}
